var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37 13c-2.7188 0-5 2.2812-5 5v5h-17c-5.4883 0-10 4.5117-10 10v44c0 5.4883 4.5117 10 10 10h70c5.4883 0 10-4.5117 10-10v-44c0-5.4883-4.5117-10-10-10h-17v-5c0-2.7188-2.2812-5-5-5zm1 6h24v4h-24zm-23 10h4.9688v52h-4.9688c-2.2695 0-4-1.7305-4-4v-44c0-2.2695 1.7305-4 4-4zm10.969 0h48.062v52h-48.062zm54.062 0h4.9688c2.2695 0 4 1.7305 4 4v44c0 2.2695-1.7305 4-4 4h-4.9688z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.ec3910dadd77751102c4aff68a1f8fb5.svg";
export { ForwardRef as ReactComponent };